import none from '../../img/leoLogo.png'

export const  breakfast=[
    {
      "id": "11",
      "title": "املت ساده",
      "desciption": "",
      "price": "125",
      "image": none
    },
    {
      "id": "12",
      "title": "املت هندی",
      "desciption": "",
      "price": "130",
      "image": none
    },
    {
      "id": "13",
      "title": "املت پپرونی",
      "desciption": "",
      "price": "135",
      "image": none
    },
    {
      "id": "14",
      "title": "چیز املت",
      "desciption": "",
      "price": "145",
      "image": none
    },
    {
      "id": "15",
      "title": "صبحانه انگلیسی",
      "desciption": "",
      "price": "280",
      "image": none
    },
    {
      "id": "16",
      "title": "سوسیس تخم مرغ",
      "desciption": "",
      "price": "170",
      "image": none
    }
  ]